
// SVG Icon: ar-hover0
export default { id: "terriajs-ar-hover0" };
export const id = "terriajs-ar-hover0";
export const name = "ar-hover0";
